import { Box } from '@mui/material'
import { useContext } from 'react'

// others
import { AppContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { NOT_APPLICABLE } from '../../constants'
import { ReferralSourceMenuProps } from '../../interfaceTypes/props'
import { useDeleteReferralSourceMutation } from '../../../generated'

// components
import { Alert } from '../common/Alert'
import CustomMenu from '../common/CustomMenu'
import { DeleteModalContent } from '../common/DeleteModalContent'
import AddReferralSource from '../referralSources/AddReferralSource'

const ReferralSource = ({ referralSource, refetch }: ReferralSourceMenuProps) => {
  const { dispatch, isOpen } = useContext(AppContext)

  const [deleteSource, { loading: deleting }] = useDeleteReferralSourceMutation({
    onError: error => {
      Alert.error(`Referral Source couldn't be deleted due to: ${error.message}`)
    },
    onCompleted: () => {
      dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
      Alert.success('Type deleted successfully')
      refetch()
    }
  })

  const onDeleteSource = async (sourceId: string) =>
    await deleteSource({ variables: { deleteReferralSourceId: sourceId } })

  return (
    <CustomMenu
      id={referralSource.id}
      menuTitle="Referral Type"
      onDelete={onDeleteSource}
      deleteContent={
        <Box mt={1}>
          <DeleteModalContent label="Type" value={referralSource.sourceType || NOT_APPLICABLE} />
        </Box>
      }
      deleting={deleting}
      modal={
        <AddReferralSource
          isOpen={isOpen}
          handleClose={() => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })}
          refetch={refetch}
          referralSource={referralSource}
        />
      }
    />
  )
}

export default ReferralSource
